import { Pipe, PipeTransform } from '@angular/core';
import { Tag } from '@zero/tags/domain';

@Pipe({
  name: 'allTagsActive',
  standalone: true,
})
export class AllTagsActivePipe implements PipeTransform {
  public transform = (activeTagsIds: string[], allTags: Tag[]) => allTags.every(({ tagId }) => activeTagsIds.includes(tagId));
}
